import "./Textarea.css";
import cn from "classnames";
import type { ComponentPropsWithRef, FC } from "react";

export const Textarea: FC<ComponentPropsWithRef<"textarea">> = (props) => {
  const { className, ...rest } = props;
  return <textarea className={cn("textarea", className)} {...rest} />;
};
